import { render, staticRenderFns } from "./proportion.vue?vue&type=template&id=3a91bf2e&scoped=true"
import script from "./proportion.vue?vue&type=script&lang=js"
export * from "./proportion.vue?vue&type=script&lang=js"
import style0 from "./proportion.vue?vue&type=style&index=0&id=3a91bf2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a91bf2e",
  null
  
)

export default component.exports